import {
  afterNextRender,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  effect,
  ElementRef,
  HostListener,
  inject,
  input,
  OnDestroy,
  OnInit,
  Signal,
  signal,
  ViewChild,
  viewChild,
} from '@angular/core';
import { Header } from '../../models/header.model';
import { CookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { EventCardInvertedComponent } from 'src/app/events/components/event-card-inverted/event-card-inverted.component';
import { Event } from 'src/app/events/models';

// Swiper
import { SwiperContainer } from 'swiper/element/bundle';
import { SwiperOptions } from 'swiper/types';

// GSAP
import { DOCUMENT } from '@angular/common';

import { ScrollTrigger } from 'gsap/ScrollTrigger';
//gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

@Component({
  selector: 'app-header-card-slider',
  imports: [EventCardInvertedComponent],
  templateUrl: './header-card-slider.component.html',
  styleUrl: './header-card-slider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderCardSliderComponent implements OnInit, OnDestroy {
  header = input.required<Header>();
  cookiePreferences = input<CookiePreferences>();
  theme = input<'secondary' | 'accent'>('secondary');
  title = input<string>();
  subTitle = input<string | null>();

  headerEl = viewChild<ElementRef<HTMLElement>>('headerEl');

  activeItem: number | undefined = 1;
  //activeItem: number | undefined = 0;
  lastActiveItem = 2;

  swiperIndex$ = signal(0);
  @ViewChild('swiper') swiperEl?: ElementRef<SwiperContainer>;
  cd = inject(ChangeDetectorRef);
  private document = inject(DOCUMENT);

  paused = false;
  activeSlideTimer: any;

  text = computed(() => {
    const text = this.subTitle() || this.header().subtitle || this.header().intro;

    // if text contains <3 replace that with a span with the class 'heart'
    return text.replace('<3', '<span class="heart"></span>');
  });

  slides: Signal<
    {
      event: Event;
      hideImage: boolean;
    }[]
  > = computed(() => {
    return this.header().headerEvents || [];
  });

  slidesUpde = effect(() => {
    const spacer = '20vh';
    const slideCount = this.slides()?.length || 0;

    this.document.body.style.setProperty('--header-spacer', slideCount > 0 ? spacer : null);
  });

  trigger: ScrollTrigger | undefined;

  @HostListener('window:resize', [])
  onResize() {
    this.swiperEl?.nativeElement.swiper.update();
  }

  constructor() {
    afterNextRender(() => {
      this.initSwiper();
      this.initScrollTrigger();
      this.startSlider();
    });
  }

  ngOnDestroy(): void {
    // Clean up interval
    if (this.activeSlideTimer) {
      clearInterval(this.activeSlideTimer);
      this.activeSlideTimer = null;
    }
    // Clean up ScrollTrigger
    if (this.trigger) {
      this.trigger.kill();
      this.trigger = undefined;
    }
    // Clean up Swiper instance
    if (this.swiperEl?.nativeElement?.swiper) {
      this.swiperEl.nativeElement.swiper.destroy(true, true);
    }
  }

  startSlider() {
    // Prevent duplicate intervals
    if (this.activeSlideTimer) {
      clearInterval(this.activeSlideTimer);
    }

    this.activeSlideTimer = setInterval(() => {
      if (this.paused || this.activeItem === undefined) {
        return;
      }
      //this.activeItem = (this.activeItem + 1) % this.slides().length;
      this.cd.detectChanges();
    }, 5000);
  }

  ngOnInit(): void {
    this.activeItem = Math.floor((this.header().events?.length || 2) / 2);
  }

  initSwiper() {
    const that = this;
    const slideCount = this.header().events?.length || 0;

    const params: SwiperOptions = {
      //loop: slideCount > 6,
      autoplay: false,
      spaceBetween: 10,
      slidesPerView: 'auto',
      //slidesPerView: 4,
      navigation: false,
      //centeredSlides: true,
      updateOnWindowResize: false,
      //slidesOffsetBefore: -50,
      //slidesOffsetAfter: 50,
      //initialSlide: Math.floor(slideCount / 2),
      mousewheel: {
        forceToAxis: true,
      },
      injectStyles: [
        `
        :host .swiper {
          overflow:inherit;
        }



        `,
      ],
      //breakpoints: {
      //  0: {
      //    slidesPerView: 1.5,
      //  },
      //  450: {
      //    slidesPerView: 2.5,
      //  },
      //  768: {
      //    slidesPerView: 3.5,
      //  },
      //  1100: {
      //    slidesPerView: 4,
      //  },
      //},
      on: {
        //realIndexChange: function (i) {
        //  that.swiperIndex$.set(i.snapIndex);
        //  console.log('swiperIndex', i);
        //  that.cd.detectChanges();
        //},
        snapIndexChange: function (i) {
          that.swiperIndex$.set(i.snapIndex);
          that.cd.detectChanges();
        },
        resize: function () {
          that.cd.detectChanges();
        },
      },
    };

    if (this.swiperEl?.nativeElement?.initialize) {
      Object.assign(this.swiperEl.nativeElement, params);
      this.swiperEl.nativeElement.initialize();
      this.cd.detectChanges();
    }
  }

  initScrollTrigger() {
    this.trigger = ScrollTrigger.create({
      trigger: '#scroll-trigger-start',
      start: 'top-=140 top+=80', // 80 = topbarheight
      endTrigger: '#scroll-trigger-end',
      end: 'bottom 100%',
      scrub: true,
      //markers: { startColor: 'green', endColor: 'red', fontSize: '18px', fontWeight: 'bold', indent: 20 },
      //onToggle: self => console.log('toggled, isActive:', self.isActive),
      onUpdate: self => {
        this.headerEl()?.nativeElement.style.setProperty('--progress', self.progress.toFixed(3));

        if (self.progress > 0.25) {
          this.activeItem = undefined;
          this.cd.detectChanges();
        } else {
          this.activeItem = this.lastActiveItem;
          this.cd.detectChanges();
        }
      },
    });

    // init on 0
    this.headerEl()?.nativeElement.style.setProperty('--progress', '0');
  }
}
